import { useState, useEffect } from 'react';
import { useTheme } from '../context/ThemeContext';
import { Sun, Moon } from 'lucide-react';

export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  // Avoid hydration mismatch by only rendering after component is mounted
  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  const isDark = theme === 'dark';

  return (
    <div className="relative">
      <button
        onClick={toggleTheme}
        className="w-16 h-8 rounded-full p-1 relative flex items-center transition-colors duration-200"
        style={{ background: 'var(--surface-active)' }}
        aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      >
        {/* Track with icons */}
        <div className="absolute inset-0 flex justify-between items-center px-2 z-20">
          {/* Sun icon on left side */}
          <Sun
            className={`h-4 w-4 ${isDark ? 'opacity-50' : ''}`}
            style={{ color: isDark ? 'var(--text-faint)' : 'var(--status-warn)' }}
          />

          {/* Moon icon on right side */}
          <Moon
            className={`h-4 w-4 ${isDark ? '' : 'opacity-50'}`}
            style={{ color: isDark ? 'var(--text-body)' : 'var(--text-faint)' }}
          />
        </div>

        {/* Plain sliding handle without icons */}
        <div
          className={`h-6 w-6 rounded-full transition-transform duration-200 z-10 shadow-md flex items-center justify-center ${
            isDark ? 'transform translate-x-8' : 'transform translate-x-0'
          }`}
          style={{ background: isDark ? 'var(--surface-canvas)' : '#FFFFFF' }}
        />
      </button>
    </div>
  );
}
